export default {
	props: {
		totalPorcent: {
			type: Number,
		},
		totalValor: {
			type: Number,
		},
		subTipo: {},
		titulo: {
			type: String,
		},
	},

	computed: {
		subTipoView() {
			return Object.entries(this.subTipo).map(([chave, valor]) => {
				const chaveCapitalizada = chave[0].toUpperCase() + chave.slice(1)
				return { label: chaveCapitalizada, value: valor }
			})
		},
	},

	template: html` <div
		class="rounded-lg border border-neutral-30 !p-12 !w-[11rem] space-y-10">
		<div class="flex items-center justify-between">
			<span class="text-xl text-neutral-75 font-semibold truncate">{{titulo}}</span>
			<q-icon
				v-if="subTipo"
				name="info"
				size="1.6rem"
				color="neutral-75"
				class="cursor-pointer">
				<q-tooltip anchor="bottom right" :offset="[10, 10]">
					<div class="rounded-lg bg-white p-14 shadow-lg">
						<p
							v-for="(item,index) of subTipoView"
							class="flex justify-between items-center gap-x-12"
							:key="index">
							<strong>{{item.label}}:</strong>
							<span class="text-neutral-75">{{item.value}}%</span>
						</p>
					</div>
				</q-tooltip>
			</q-icon>
		</div>
		<div>
			<p class="text-2xl font-bold text-[#0e171e]">{{totalPorcent}}%</p>
		</div>
		<div>
			<span class="text-neutral-75">R$ {{totalValor}}</span>
		</div>
	</div>`,
}
